import Vue from 'vue'
import Router from 'vue-router'

const Home = resolve => require(['@/views/Home'], resolve)
const Calculator = resolve => require(['@/views/Calculator'], resolve)
const CalculatorEx = resolve => require(['@/views/CalculatorEx'], resolve)
const Unit = resolve => require(['@/views/Unit'], resolve)
const UnitDetail = resolve => require(['@/views/UnitDetail'], resolve)
const UnitTemperature = resolve => require(['@/views/UnitTemperature'], resolve)
// const Rmb = resolve => require(['@/views/Rmb'], resolve)
const Equation = resolve => require(['@/views/Equation'], resolve)
const Number = resolve => require(['@/views/Number'], resolve)
const Point24Game = resolve => require(['@/views/Point24Game'], resolve)
const VerticalCalculator = resolve => require(['@/views/VerticalCalculator'], resolve)
const Luoma = resolve => require(['@/views/Luoma'], resolve)
const Hex = resolve => require(['@/views/Hex'], resolve)
const HexCalculator = resolve => require(['@/views/HexCalculator'], resolve)
const Binary = resolve => require(['@/views/Binary'], resolve)
const FractionCalculator = resolve => require(['@/views/FractionCalculator'], resolve)

const Error404 = resolve => require(['@/views/error/Error404'], resolve)

Vue.use(Router)

let routes = [
    { path: '/rmb', component: resolve => require(['@/views/Rmb'], resolve) },
    { path: '/rmb/batch', component: resolve => require(['@/views/RmbBatch'], resolve) },
    {
        path: '/',
        component: Home
    },
    {
        path: '/fractionCalculator',
        component: FractionCalculator
    },
    {
        path: '/calculator',
        component: Calculator
    },
    {
        path: '/luoma',
        component: Luoma
    },
    {
        path: '/hex',
        component: Hex
    },
    {
        path: '/hex/calculator',
        component: HexCalculator
    },
    {
        path: '/ex',
        component: CalculatorEx
    },
    {
        path: '/number',
        component: Number
    },
    {
        path: '/unit',
        component: Unit
    },
    {
        path: '/unit/temperature',
        component: UnitTemperature
    },
    {
        path: '/unit/:type',
        component: UnitDetail
    },
    {
        path: '/equation',
        component: Equation
    },
    {
        path: '/point24/game',
        component: Point24Game
    },
    {
        path: '/vertical_calculator',
        component: VerticalCalculator
    },
    {
        path: '/binary/calculator',
        component: Binary
    },
    {
        path: '*',
        component: Error404
    }
]

let router = new Router({
    mode: 'history',
    routes: routes,
    scrollBehavior (to, from, savedPosition) {
        return {
            x: 0,
            y: 0
        }
    }
})

router.beforeEach((to, from, next) => {
    next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js